import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wsg-dashboard-container',
  template: ''
})
export class DashboardContainerComponent implements OnInit {

  @Input() dashboardItem;

  constructor() { }

  ngOnInit() {
  }

}
